module.exports = __webpack_public_path__ + "static/assets/59b93b7e485974be6aea451fce153e4b.png";